import Vue from 'vue';
const state = {
    supply: {},
    supplies: [],
}
const actions = {
    showSupplies: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/supplies`).then(response => {
                context.commit('SHOW_SUPPLYS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showSupply: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/supplies/${id}`).then(response => {
                context.commit('SHOW_SUPPLY', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeSupply: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/supplies`, payload).then(response => {
                Vue.$toast.success("Suprimento registrado com sucesso");
                context.commit('STORE_SUPPLY', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateSupply: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/supplies/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroySupply: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/supplies/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_SUPPLY: (state, payload) => {
        state.supply = payload
    },
    SHOW_SUPPLIES: (state, payload) => {
        state.supplies = payload
    },
    STORE_SUPPLY: (state, payload) => {
        state.supply = payload
    }
}
const getters = {
    supply: state => {
        return state.supply
    },
    supplies: state => {
        return state.supplies
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}